import React from 'react';
import './WhoWeAre.css';

const WhoWeAre = () => {
  return (
    <div><p>WhoWeAre</p></div>
  )
}

export default WhoWeAre;